export default __webpack_public_path__ + "static/media/Sweden.34559b63.svg";